import { Button } from '@/shared/components/ui/button';
import { Link, useParams } from 'react-router-dom';
import { useGroupSuspense } from '@/features/groups/api/get-group';
import { CheckCircle2 } from 'lucide-react';
import { GroupContextGate } from '@/features/groups/component/group-context-gate';

export function MembershipRegistered() {
  const groupId = useParams().groupId!;

  return (
    <GroupContextGate groupId={groupId}>
      <Registered groupId={groupId} />
    </GroupContextGate>
  );
}

function Registered({ groupId }: { groupId: string }) {
  const { data } = useGroupSuspense({ groupId });

  return (
    <div className="flex flex-col items-center gap-8 p-4 max-w-md mx-auto">
      <CheckCircle2 className="size-16 text-emerald-400" />

      <h2 className="text-2xl font-bold text-center">Grattis! Nu är du medlem i {data.name}! 🔥</h2>

      <Button variant={'outline'} asChild>
        <Link to="/">Gå till plattformen</Link>
      </Button>
    </div>
  );
}
